import React, { useState, useEffect } from 'react';
import CariSupplier from './CariSupplier';
import CariBank from './CariBank';
import CariCoa from './CariCoa';
import CariHutang from './CariHutang';

function InputBk({ onCancel, onSave, editMode, pasang, title }) {
  const [tglTransaksi, setTglTransaksi] = useState('');
  const [noTransaksi, setNoTransaksi] = useState('');
  const [kd_rekanan, setKd_rekanan] = useState('');
  const [namarekanan, setNamarekanan] = useState('');
  const [kd_rek_gl, setKd_rek_gl] = useState('');
  const [namarekening, setNamarekening] = useState('');
  const [cara_bayar, setCara_bayar] = useState('');
  const [keterangan, setKeterangan] = useState('');
  const [status, setStatus] = useState('');
  const [detailBarang, setDetailBarang] = useState([]);
  const [idUser, setIdUser] = useState('');
  const [canUnvalid, setCanUnvalid] = useState(true);
  const [showSupplierLookup, setShowSupplierLookup] = useState(false);
  const [showRekeningLookup, setShowRekeningLookup] = useState(false);
  const [showHutangLookup, setShowHutangLookup] = useState(false);
  const [showCoaLookup, setShowCoaLookup] = useState(false);

  const schema = localStorage.getItem('schema');

  useEffect(() => {
    const today = new Date();
    const formattedToday = today.toISOString().split('T')[0];

    if (editMode && pasang) {
      const { master, details } = pasang;
      setTglTransaksi(formatDateForInput(master.TGL_TRANSAKSI));
      setNoTransaksi(master.NO_TRANSAKSI || '');
      setKd_rekanan(master.KD_REKANAN || '');
      setNamarekanan(master.NAMAREKANAN || '');
      setKd_rek_gl(master.KD_REK_GL || '');
      setNamarekening(master.NAMAREKENING || '');
      setCara_bayar(master.CARA_BAYAR || 'Tunai');
      setKeterangan(master.KETERANGAN || '');
      setStatus(master.STATUS || '');

      if (details && Array.isArray(details)) {
        setDetailBarang(details);
      } else {
        setDetailBarang([]);
      }
    } else if (pasang?.isNew) {
      setNoTransaksi(0);
      setTglTransaksi(formattedToday);
    }

    const idUser = localStorage.getItem('id_user') || '';
    setIdUser(idUser);
  }, [editMode, pasang]);

  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return '';
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const formatNumber = (num) => {
    if (isNaN(num) || num === null) return '';
    return Number(num).toLocaleString('id-ID');
  };

const formatInputNumber = (value) => {
  if (!value) return '';
  const number = value.toString().replace(/\D/g, '');  
  return Number(number).toLocaleString('id-ID');
};


  const totalKeseluruhan = detailBarang.reduce(
    (sum, item) => sum + (Number(item.TOTAL) || 0),
    0
  );

  const handleValidasi = async () => {
    const id = noTransaksi || '0';

    try {
      const formData = new URLSearchParams();
      formData.append('caller', 'bk');
      formData.append('id', id);
      formData.append('schema', schema);
      formData.append('id_user', idUser);
      formData.append('tgl_transaksi', tglTransaksi);
      formData.append('keterangan', keterangan);
      formData.append('kd_rekanan', kd_rekanan);
      formData.append('rekanan', namarekanan);
      formData.append('kd_rek_gl', kd_rek_gl);
      formData.append('cara_bayar', cara_bayar||'Tunai');
      
      formData.append('detail', JSON.stringify(detailBarang));

      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/bk.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });

      const result = await response.json();

      if (result.status !== 'success') {
        alert(`Gagal validasi master: ${result.message}`);
        return;
      }

      onSave();
    } catch (err) {
      console.error('Error saat validasi BK:', err);
      alert('Terjadi kesalahan saat menyimpan BK dan detail.');
    }
  };

  const handleHapusDetail = (index) => {
    const updated = detailBarang.filter((_, i) => i !== index);
    const reindexed = updated.map((item, idx) => ({
      ...item,
      NOMOR: idx + 1,
    }));
    setDetailBarang(reindexed);
  };

  const handleUnvalid = async () => {
    const id = noTransaksi || '0';

    try {
      const formData = new URLSearchParams();
      formData.append('caller', 'bk_unvalid');
      formData.append('id', id);
      formData.append('schema', schema);

      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/bk.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });

      const result = await response.json();

      if (result.status === 'success') {
        setStatus('0');
        alert('BKK berhasil unvalid');
      } else {
        alert(`Gagal validasi: ${result.message}`);
      }
    } catch (err) {
      console.error('Validasi error:', err);
      alert('Terjadi kesalahan saat validasi BKK.');
    }
  };

  const handleDelete = async () => {
    const id = noTransaksi || '0';

    try {
      const formData = new URLSearchParams();
      formData.append('caller', 'bk_hapus');
      formData.append('id', id);
      formData.append('schema', schema);

      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/bk.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });

      const result = await response.json();

      if (result.status === 'success') {
        alert('BK berhasil dihapus');
        onSave();
      } else {
        alert(`Gagal validasi: ${result.message}`);
      }
    } catch (err) {
      console.error('Validasi error:', err);
      alert('Terjadi kesalahan saat hapus BK.');
    }
  };

  const handleSelectSupplier = (selectedSupplier) => {
    setKd_rekanan(selectedSupplier.KD_REKANAN);
    setNamarekanan(selectedSupplier.NAMAREKANAN);
    setShowSupplierLookup(false);
  };

  const handleSelectRekening = (selectedRekening) => {
    setKd_rek_gl(selectedRekening.KD_REK_GL);
    setNamarekening(selectedRekening.NAMAREKENING);
    setShowRekeningLookup(false);
  };
 

  return (
<div style={{ padding: '20px', backgroundColor: '#fff', borderRadius: '10px', boxShadow: '0 0 10px rgba(0,0,0,0.1)' }}>
  <h2 style={{ marginBottom: '20px', color: '#4A4A4A' }}>{title}</h2>

<>

{showSupplierLookup && (
  <CariSupplier
    onSelect={handleSelectSupplier}
    onCancel={() => setShowSupplierLookup(false)}
  />
)}

{showRekeningLookup && (
  <CariBank
    onSelect={handleSelectRekening}
    onCancel={() => setShowRekeningLookup(false)}
  />
)}

{showCoaLookup && (
  <CariCoa
    onSelect={(selectedRek) => {
      const newItem = {
        NOMOR: detailBarang.length + 1,
        KD_REK_GL: selectedRek.KD_REK_GL,
        NAMAREKENING: selectedRek.NAMAREKENING,
        NO_NOTA: '',
        TOTAL: 0,
        KETERANGAN: '',
      };
      setDetailBarang([...detailBarang, newItem]);
      setShowCoaLookup(false);
    }}
    onCancel={() => setShowCoaLookup(false)}
  />
)}
              
{showHutangLookup && (
  <CariHutang
    kd_rekanan={kd_rekanan}
    selectedNotes={detailBarang.map((item) => item.NO_NOTA)} 
    onSelect={(selectedHutang) => {
      const newItem = {
        NOMOR: detailBarang.length + 1,
        KD_REK_GL: selectedHutang.KD_PERKIRAAN,
        NAMAREKENING: selectedHutang.NAMAREKENING,
        NO_NOTA: selectedHutang.NO_TRANSAKSI,
        TOTAL: selectedHutang.TOTAL || 0,
        KETERANGAN: '',
      };
      setDetailBarang([...detailBarang, newItem]);
      setShowHutangLookup(false);
    }}
    onCancel={() => setShowHutangLookup(false)}
  />
)}


<div>
  <label><strong>No Transaksi</strong></label>
  <input type="text" readOnly value={noTransaksi}
    style={{ width: '100%', padding: '8px', backgroundColor: '#E6E6E6', borderRadius: '5px', marginBottom: 10 }}
  />
</div>

<div>
  <label><strong>Tanggal</strong></label>
  <input type="date" value={tglTransaksi} onChange={(e) => setTglTransaksi(e.target.value)}
    style={{ width: '100%', padding: '8px', borderRadius: '5px', marginBottom: 10 }}
  />
</div>

<div style={{ marginBottom: '10px' }}>
  <label>Rekanan</label>
  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', alignItems: 'center' }}>
    <input type="text" value={kd_rekanan} readOnly style={{ width: '100px', padding: '5px', backgroundColor: '#E6E6E6' }} />
    <input type="text" value={namarekanan} readOnly style={{ flex: 1, padding: '5px', backgroundColor: '#E6E6E6' }} />
    <button onClick={() => setShowSupplierLookup(true)} disabled={['9', '5', '6'].includes(status)}
      style={{ marginTop: '10px', marginBottom: '10px', padding: '5px 10px', backgroundColor: '#00A2E8', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
      Cari
    </button>
  </div>
</div>

<div style={{ marginBottom: '10px' }}>
  <label>Bank</label>
  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', alignItems: 'center' }}>
    <input type="text" value={kd_rek_gl} readOnly style={{ width: '100px', padding: '5px', backgroundColor: '#E6E6E6' }} />
    <input type="text" value={namarekening} readOnly style={{ flex: 1, padding: '5px', backgroundColor: '#E6E6E6' }} />
    <button onClick={() => setShowRekeningLookup(true)} disabled={['9', '5', '6'].includes(status)}
      style={{ marginTop: '10px', marginBottom: '10px', padding: '5px 10px', backgroundColor: '#00A2E8', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
      Cari
    </button>
  </div>
</div>

<div style={{ marginBottom: '10px' }}>
  <label>Cara Bayar</label>
  <select value={cara_bayar} onChange={(e) => setCara_bayar(e.target.value)} style={{ width: '100%', padding: '5px', marginBottom: '10px' }}
      disabled={status === '5' || status === '6' || status === '9'}
      >
    <option value="Tunai">Tunai</option>
    <option value="Transfer">Transfer</option>
    <option value="Giro">Giro</option>
  </select>
</div>

<div style={{ marginBottom: '20px' }}>
  <label><strong>Keterangan</strong></label>
  <textarea value={keterangan} onChange={(e) => setKeterangan(e.target.value)} rows={3}
    disabled={status === '5' || status === '6' || status === '9'}
    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }} />
</div>


<div style={{ textAlign: 'right', marginBottom: '15px', display: 'flex', gap: '10px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
  <button
    onClick={() => setShowCoaLookup(true)}
    disabled={['5', '6', '9'].includes(status)}
    style={{ backgroundColor: '#00A2E8', color: 'white', padding: '8px 14px', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px', }} >
    ➕ Add Detail COA
  </button>

  <button
    onClick={() => setShowHutangLookup(true)}
    disabled={['5', '6', '9'].includes(status)}
    style={{ backgroundColor: '#F9A825', color: 'white', padding: '8px 14px', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px', }} >
    ➕ Add Nota Hutang
  </button>
</div>



{detailBarang.length > 0 ? (
  (() => {
    const isMobile = window.innerWidth <= 600;

    return isMobile ? (
      // ======== 📱 MOBILE: CARD STYLE ========
      <div
        style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 10, marginBottom: 20, }} >
        {detailBarang.map((item, index) => (
          <div
            key={index}
            style={{ width: '95%', backgroundColor: '#fff', borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.1)', padding: 12, marginBottom: 12, }} >
            <div style={{ marginBottom: 10 }}>
              <strong>Rekening</strong>
              <div>{item.KD_REK_GL} {item.NAMAREKENING}</div>
            </div>

            <div style={{ marginBottom: 10 }}>
              <strong>No. Nota</strong>
              <div>{item.NO_NOTA}</div>
            </div>

            <div style={{ marginBottom: 10 }}>
              <strong>Total</strong>
              <input
                type="text"
                value={formatInputNumber(item.TOTAL)}
                disabled={['5', '6', '9'].includes(status)}
                onChange={(e) => {
                  const raw = e.target.value.replace(/\D/g, ''); 
                  const updated = [...detailBarang];
                  updated[index].TOTAL = raw ? Number(raw) : 0;
                  setDetailBarang(updated);
                }}
                style={{ width: '100%', textAlign: 'right', padding: '6px', borderRadius: '6px', border: '1px solid #ccc', fontSize: 15, }} />
            </div>

            <div style={{ marginBottom: 10 }}>
              <strong>Keterangan</strong>
              <textarea
                value={item.KETERANGAN}
                disabled={['5', '6', '9'].includes(status)}
                onChange={(e) => {
                  const updated = [...detailBarang];
                  updated[index].KETERANGAN = e.target.value;
                  setDetailBarang(updated);
                }}
                rows={3}
                style={{ width: '100%', padding: '6px', borderRadius: '6px', border: '1px solid #ccc', fontSize: 14, resize: 'none', }} />
            </div>

            <div style={{ textAlign: 'right', marginTop: 8 }}>
              <button
                onClick={() => handleHapusDetail(index)}
                disabled={['5', '6', '9'].includes(status)}
                style={{ backgroundColor: '#e53935', color: 'white',  border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 14, fontWeight: 'bold',
                  cursor: ['5', '6', '9'].includes(status) ? 'not-allowed' : 'pointer',
                  opacity: ['5', '6', '9'].includes(status) ? 0.6 : 1,
                  boxShadow: '0 2px 4px rgba(229,57,53,0.3)', }} >
                🗑️ Hapus
              </button>
            </div>
          </div>
        ))}

        <div
          style={{width: '95%', backgroundColor: '#e3f2fd', padding: '12px 14px', borderRadius: 10, textAlign: 'right', fontWeight: 'bold', color: '#0d47a1', fontSize: 15, boxShadow: '0 1px 4px rgba(0,0,0,0.1)', }} >
          Total Keseluruhan:{' '}
          {formatNumber(
            detailBarang.reduce((sum, item) => sum + Number(item.TOTAL || 0), 0)
          )}
        </div>
      </div>
    ) : (
      // ======== 💻 DESKTOP: TABLE STYLE ========
      <div style={{ marginTop: 20, marginBottom: 20, overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14, }}>
          <thead style={{ backgroundColor: '#f0f0f0' }}>
            <tr>
              <th style={{ border: '1px solid #ccc', padding: 8 }}>No</th>
              <th style={{ border: '1px solid #ccc', padding: 8 }}>Rekening</th>
              <th style={{ border: '1px solid #ccc', padding: 8 }}>No Nota</th>
              <th style={{ border: '1px solid #ccc', padding: 8 }}>Total</th>
              <th style={{ border: '1px solid #ccc', padding: 8 }}>Keterangan</th>
              <th style={{ border: '1px solid #ccc', padding: 8 }}>Aksi</th>
            </tr>
          </thead>
          <tbody>
            {detailBarang.map((item, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? '#fff' : '#fafafa',
                }}
              >
                <td style={{ border: '1px solid #ccc', padding: 6, textAlign: 'center' }}>
                  {index + 1}
                </td>
                <td style={{ border: '1px solid #ccc', padding: 6 }}>
                  {item.KD_REK_GL} - {item.NAMAREKENING}
                </td>
                <td style={{ border: '1px solid #ccc', padding: 6 }}>{item.NO_NOTA}</td>
                <td style={{ border: '1px solid #ccc', padding: 6, width: '120px' }}>
                  <input
                    type="text"
                    value={formatInputNumber(item.TOTAL)}
                    disabled={['5', '6', '9'].includes(status)}
                    onChange={(e) => {
                      const raw = e.target.value.replace(/\D/g, '');
                      const updated = [...detailBarang];
                      updated[index].TOTAL = raw ? Number(raw) : 0;
                      setDetailBarang(updated);
                    }}
                    style={{ width: '95%', textAlign: 'right', padding: '4px', borderRadius: '4px', border: '1px solid #ccc', }}
                  />

                </td>
                <td style={{ border: '1px solid #ccc', padding: 6 }}>
                  <textarea
                    value={item.KETERANGAN}
                    disabled={['5', '6', '9'].includes(status)}
                    onChange={(e) => {
                      const updated = [...detailBarang];
                      updated[index].KETERANGAN = e.target.value;
                      setDetailBarang(updated);
                    }}
                    rows={1}
                    style={{ width: '95%', borderRadius: '4px', border: '1px solid #ccc', padding: '4px', fontSize: 13, }} />
                </td>
                <td style={{ border: '1px solid #ccc', padding: 6, textAlign: 'center', }} >
                  <button
                    onClick={() => handleHapusDetail(index)}
                    disabled={['5', '6', '9'].includes(status)}
                    style={{ backgroundColor: '#e53935', color: 'white',  border: 'none', borderRadius: 6, padding: '6px 12px', fontSize: 13,
                      cursor: ['5', '6', '9'].includes(status) ? 'not-allowed' : 'pointer', opacity: ['5', '6', '9'].includes(status) ? 0.6 : 1, }} >
                    🗑️
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div
          style={{ marginTop: 10, textAlign: 'right', fontWeight: 'bold', color: '#0d47a1', }} >
          Total Keseluruhan:{' '}
          {formatNumber(detailBarang.reduce((sum, item) => sum + Number(item.TOTAL || 0), 0) )}
        </div>
      </div>
    );
  })()
) : (
  <p style={{ color: '#888' }}>Tidak ada detail.</p>
)}



<div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '15px' }}>
  <button onClick={handleUnvalid} disabled={!canUnvalid || ['5', '6'].includes(status)}
    style={{ backgroundColor: !canUnvalid || ['5', '6'].includes(status) ? '#A5D6A7' : 'red', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '5px' }}>
    Un-valid
  </button>
  <button onClick={handleDelete} disabled={['9', '5', '6'].includes(status)}
    style={{ backgroundColor: ['9', '5', '6'].includes(status) ? '#A5D6A7' : 'red', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '5px' }}>
    Delete
  </button>
  <button onClick={onCancel} style={{ backgroundColor: 'blue', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '5px' }}>
    Batal
  </button>
  <button onClick={handleValidasi} disabled={['5', '6', '9'].includes(status)}
    style={{ backgroundColor: ['5', '6', '9'].includes(status) ? '#A5D6A7' : 'green', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '5px' }}>
    Valid
  </button>
</div>



</>
</div>
);
}

export default InputBk;
